import { render, staticRenderFns } from "./CategorySelectionGroup.vue?vue&type=template&id=c5a3741c&scoped=true&"
import script from "./CategorySelectionGroup.vue?vue&type=script&lang=js&"
export * from "./CategorySelectionGroup.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelectionGroup.vue?vue&type=style&index=0&id=c5a3741c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a3741c",
  null
  
)

export default component.exports